// Mi tienda — scripts propios (vanilla JS, sin librerías externas)

function mtInitReveals() {
  const els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach((el, i) => {
    el.style.setProperty('--mt-delay', (i % 6) * 90 + 'ms');
    observer.observe(el);
  });
}

function mtInitFaq() {
  document.querySelectorAll('.mt-faq').forEach((faq) => {
    const items = faq.querySelectorAll('.mt-faq-item');
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (item.open) {
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  });
}

function mtInitContadores() {
  const els = document.querySelectorAll('.mt-contador[data-hasta]');
  if (!els.length) return;
  const anima = (el) => {
    const hasta = parseFloat(el.dataset.hasta) || 0;
    const decimales = el.dataset.decimales ? parseInt(el.dataset.decimales, 10) : 0;
    const sufijo = el.dataset.sufijo || '';
    const duracion = 1400;
    const inicio = performance.now();
    function paso(ahora) {
      const t = Math.min(1, (ahora - inicio) / duracion);
      const suave = 1 - Math.pow(1 - t, 3);
      el.textContent = (hasta * suave).toFixed(decimales) + sufijo;
      if (t < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  };
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => {
      const hasta = parseFloat(el.dataset.hasta) || 0;
      const decimales = el.dataset.decimales ? parseInt(el.dataset.decimales, 10) : 0;
      el.textContent = hasta.toFixed(decimales) + (el.dataset.sufijo || '');
    });
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          anima(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );
  els.forEach((el) => observer.observe(el));
}

function mtInitGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria]').forEach((galeria) => {
    const principal = galeria.querySelector('[data-mt-galeria-principal]');
    const miniaturas = galeria.querySelectorAll('[data-mt-galeria-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach((mini) => {
      mini.addEventListener('click', () => {
        const src = mini.dataset.mtGaleriaMiniatura;
        if (!src) return;
        principal.src = src;
        miniaturas.forEach((m) => m.classList.remove('mt-activa'));
        mini.classList.add('mt-activa');
      });
    });
  });
}

function mtInitCantidad() {
  document.querySelectorAll('[data-mt-cantidad]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    const menos = wrap.querySelector('[data-mt-menos]');
    const mas = wrap.querySelector('[data-mt-mas]');
    if (!input) return;
    menos && menos.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    mas && mas.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

function mtInitSelectorVariantes() {
  document.querySelectorAll('[data-mt-producto-form]').forEach((form) => {
    const datosEl = form.querySelector('[data-mt-variantes-json]');
    if (!datosEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }
    const inputId = form.querySelector('input[name="id"]');
    const precioEl = form.querySelector('[data-mt-precio]');
    const precioAntesEl = form.querySelector('[data-mt-precio-antes]');
    const botonAgregar = form.querySelector('[data-mt-agregar]');
    const cantidadInput = form.querySelector('[data-mt-cantidad] input');
    const grupos = form.querySelectorAll('[data-mt-opcion]');

    function formatearDinero(centavos) {
      if (window.Shopify && window.Shopify.formatMoney && window.themeMoneyFormat) {
        return window.Shopify.formatMoney(centavos, window.themeMoneyFormat);
      }
      return (centavos / 100).toFixed(2);
    }

    function seleccionActual() {
      return Array.from(grupos).map((g) => {
        const activo = g.querySelector('.mt-activa');
        return activo ? activo.dataset.mtValor : null;
      });
    }

    function encontrarVariante() {
      if (grupos.length === 0) return variantes[0];
      const sel = seleccionActual();
      return variantes.find((v) => v.options.every((op, i) => op === sel[i]));
    }

    function actualizar() {
      const variante = encontrarVariante();
      if (!variante) {
        if (botonAgregar) {
          botonAgregar.disabled = true;
          botonAgregar.textContent = form.dataset.mtTextoAgotado || 'No disponible';
        }
        return;
      }
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatearDinero(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatearDinero(variante.compare_at_price);
          precioAntesEl.hidden = false;
        } else {
          precioAntesEl.hidden = true;
        }
      }
      if (botonAgregar) {
        if (variante.available) {
          botonAgregar.disabled = false;
          botonAgregar.textContent = form.dataset.mtTextoComprar || 'Añadir al carrito';
        } else {
          botonAgregar.disabled = true;
          botonAgregar.textContent = form.dataset.mtTextoAgotado || 'Agotado';
        }
      }
    }

    grupos.forEach((grupo) => {
      grupo.querySelectorAll('[data-mt-valor]').forEach((btn) => {
        btn.addEventListener('click', () => {
          grupo.querySelectorAll('[data-mt-valor]').forEach((b) => b.classList.remove('mt-activa'));
          btn.classList.add('mt-activa');
          actualizar();
        });
      });
    });

    if (cantidadInput) {
      cantidadInput.addEventListener('change', () => {
        if (parseInt(cantidadInput.value, 10) < 1) cantidadInput.value = 1;
      });
    }

    actualizar();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  mtInitReveals();
  mtInitFaq();
  mtInitContadores();
  mtInitGaleriaProducto();
  mtInitCantidad();
  mtInitSelectorVariantes();
});
